import instance from '../axios';

export const getAll = async (selectedFilter) => {
  const response = await instance.get(`invoices?filter=` + selectedFilter);
  return response.data;
};
export const getForDownload = async (selectedFilter) => {
  const response = await instance.get(`invoices/getForDownload?filter=` + selectedFilter);
  return response.data;
};
export const getDetails = async (id) => {
  const response = await instance.get(`invoices/` + id);
  return response.data;
};
export const getDropdown = async () => {
  const response = await instance.get(`invoices/getDropdown`);
  return response.data;
};
export const generateNumber = async () => {
  const response = await instance.get(`invoices/generateNumber`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`invoices`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`invoices`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`invoices/` + id);
  return response;
};
